var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container mt-3 py-3"})
}
var staticRenderFns = []

export { render, staticRenderFns }